import videojs from 'video.js';

const Plugin = videojs.getPlugin('plugin');

const defaultOptions = {
	horizontal: []
};

export default class CssBreakpoints extends Plugin {
	constructor(player, options) {
		super(player);

		const mergedOptions = videojs.mergeOptions(defaultOptions, options);

		const playerResizeHandler = () => {
			const currentPlayerWidth = this.player.currentWidth();
			const activeBreakpoint = Math.min(...mergedOptions.horizontal.filter(breakpoint => breakpoint >= currentPlayerWidth));
			this.player.el().dataset.cssBreakpoint = activeBreakpoint;
		};

		this.player.ready(() => {
			this.player.addClass('vjs-breakpoints');
			playerResizeHandler();
		});

		this.player.on('playerresize', playerResizeHandler);
	}
}

videojs.registerPlugin('cssBreakpoints', CssBreakpoints);
